/* eslint-disable */
/// This file is auto generated - do not edit manually
export const ShowGiftCard = 'Website.Checkout.GiftCard.ShowGiftCard';
export const HideGiftCard = 'Website.Checkout.GiftCard.HideGiftCard';
export const PayByGiftCard = 'Website.Checkout.GiftCard.PayByGiftCard';
export const PaymentWithGiftCard = 'Website.Checkout.GiftCard.PaymentWithGiftCard';
export const AddGiftCard = 'Website.Checkout.GiftCard.AddGiftCard';
export const CardNumber = 'Website.Checkout.GiftCard.CardNumber';
export const CVC = 'Website.Checkout.GiftCard.CVC';
export const Activate = 'Website.Checkout.GiftCard.Activate';
export const RemoveGiftCard = 'Website.Checkout.GiftCard.RemoveGiftCard';
export const GiftCardVerified = 'Website.Checkout.GiftCard.GiftCardVerified';
export const GiftCardAlreadyAdded = 'Website.Checkout.GiftCard.GiftCardAlreadyAdded';
export const GiftCardEmpty = 'Website.Checkout.GiftCard.GiftCardEmpty';
export const GiftCardAdjust = 'Website.Checkout.GiftCard.GiftCardAdjust';
export const ToolTipText = 'Website.Checkout.GiftCard.ToolTipText';
export const GiftCardDisabled = 'Website.Checkout.GiftCard.GiftCardDisabled';
